import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Definiciones from './definiciones';
import Encabezado from './encabezado';
import AspectosGenerales from './aspectosGenerales';
import UsuariosYClientes from './usuariosYClienteCorporativos';
import AccesoALasPlataformas from './accesoPlataformas';
import AccesoALaLanding from './accesoALaLanding';
import AccesoYUsoDeLaPaginaWeb from './accesoYUsoPaginaWeb';
import Servicios from './servicios';
import MediosDePago from './mediosDePago';
import DerechosYDeberes from './derechosYDeberes';
import DerechoDeRetracto from './derechoDeRetracto';
import CanalesYResponsabilidad from './canalesYResponsabilidades';
import DevolucionesYResponsabilidad from './devolucionesYResponsabilidad';
import PrevencionSAGRILAFT from './prevencionLavadoDeActivos';
import TransparenciaYPrivacidad from './transparenciaYPrivacidad';
import OtrasDisposiciones from './otrasDisposiciones';
import DerechoDeAdmision from './derechoAdmicion';
import TerminosGeneralesServicio from './terminosGenerlesServicio';

export default function TyCPage() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={16} md={20}>
          <Encabezado />
          <AspectosGenerales />
          <Definiciones />
          <UsuariosYClientes />
          <AccesoALasPlataformas />
          <AccesoALaLanding />
          <AccesoYUsoDeLaPaginaWeb />
          <Servicios />
          <MediosDePago />
          <DerechosYDeberes />
          <DerechoDeRetracto />
          <CanalesYResponsabilidad />
          <DevolucionesYResponsabilidad />
          <PrevencionSAGRILAFT />
          <TransparenciaYPrivacidad />
          <OtrasDisposiciones />  
          <DerechoDeAdmision />
          <TerminosGeneralesServicio />

          <p className="mt-5 text-muted text-center" style={{ fontSize: '0.8rem' }}>
            Última actualización: 2 de septiembre de 2025
          </p>
        </Col>
      </Row>
    </Container>
  );
}